// Identificação do app para a telemetria do Painel de Dados (InovaSupport).
// Bump APP_VERSION a cada release relevante da Impressão Web.
export const APP_NAME = "impressao";
export const APP_VERSION = "3.0.0";

// Plataforma "Web/<SO>" a partir do user agent (telemetria/contexto).
export function detectarPlataformaWeb(): string {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  if (/Windows/i.test(ua)) return "Web/Windows";
  if (/Android/i.test(ua)) return "Web/Android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "Web/iOS";
  if (/Mac/i.test(ua)) return "Web/macOS";
  if (/Linux/i.test(ua)) return "Web/Linux";
  return "Web";
}
